module.exports = __webpack_public_path__ + "media/images/banner/becos/crowdfundingBannerV3-66bc2746181c270182b68b5cef0d0bdd.jpeg";